<script lang="ts">
	import { superForm } from 'sveltekit-superforms';
	import { Button } from '$lib/components/ui/button';
	import * as Form from '$lib/components/ui/form';
	import { Input } from '$lib/components/ui/input';
	import LogoFull from '$lib/components/atoms/logo-full.svelte';

	export let data;

	const form = superForm(data.form);

	const { enhance, submitting } = form;
</script>

<div
	class="relative h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0"
>
	<div class="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
		<div class="absolute inset-0 bg-zinc-900" />
		<div class="relative z-20 flex items-center text-lg font-medium">
			<LogoFull reversedMode class="w-[200px]" />
		</div>
		<div class="relative z-20 mt-auto">
			<blockquote class="space-y-2">
				<p class="text-lg">
					"Adhyaksa Mart Voucher adalah aplikasi yang memudahkan kamu dalam mengelola voucher
					didalam toko Adhyaksa Mart."
				</p>
			</blockquote>
		</div>
	</div>
	<div class="flex h-full items-center p-4 lg:p-8">
		<div class="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[400px]">
			<div class="flex flex-col space-y-2 text-center">
				<h1 class="text-2xl font-semibold tracking-tight">Adhyaksa Mart Voucher</h1>
				<p class="text-sm text-muted-foreground">
					Masukkan email dan password untuk masuk ke dalam sistem
				</p>
			</div>
			<form class="mt-4 flex flex-col space-y-2" method="POST" use:enhance>
				<Form.Field {form} name="username">
					<Form.Control let:attrs>
						<Form.Label>Username</Form.Label>
						<Input {...attrs} />
					</Form.Control>
					<Form.FieldErrors />
				</Form.Field>

				<Form.Field {form} name="password">
					<Form.Control let:attrs>
						<Form.Label>Password</Form.Label>
						<Input type="password" {...attrs} />
					</Form.Control>
					<Form.FieldErrors />
				</Form.Field>

				<Button loading={$submitting} class="mt-2" type="submit">Masuk</Button>
			</form>
		</div>
	</div>
</div>
